import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { IssuesPage } from "@/features/issues/IssuesPage";
import { issuesQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

const search = projectSearch.extend({ status: z.enum(["open", "muted", "resolved"]).optional() });

export const Route = createFileRoute("/w/$workspace/p/$project/issues")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(issuesQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <IssuesPage
        workspace={workspace}
        project={project}
        env={s.env ?? DEFAULT_ENV}
        status={s.status ?? "open"}
        onStatus={(status) =>
          navigate({
            search: (prev) => ({ env: prev.env, status: status === "open" ? undefined : status }),
            replace: true,
          })
        }
      />
    );
  },
});
